<template>
  <Navbar2 />
  <!-- Breadcrumb Area  -->
  <div class="breadcrumb-area section-padding light-bg-1 pb-0">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 col-lg-9 col-md-9 col-12">
          <div class="section-title">
            <p>About Afino Tax Consultants</p>
            <h2>Your Partner in Compliance & Financial Growth</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-12">
          <div class="direction-img">
            <img src="/assets/img/shape/shape-about.png" alt="" />
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12">
          <h3>Our Mission</h3>
          <p>
            To empower businesses through reliable, compliant, and transparent financial services 
            that simplify complex tax and accounting requirements, allowing clients to focus on growth and innovation.
          </p>
          <h3 class="mt-40">Our Vision</h3>
          <p>
            To be recognized as one of the UAE's most trusted and professional tax and accounting consultancies, 
            delivering excellence, innovation, and integrity in every engagement.
          </p>
        </div>
      </div>
      <div class="row mt-90">
        <div class="col-12">
          <div class="bread-bg">
            <img src="/assets/img/breadcrumb/about_banner.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Our Values Section -->
  <div class="feature-section section-padding white-bg">
    <div class="container">
      <div class="row">
        <div class="col-xl-12 text-center">
          <div class="section-title">
            <p>Our Values</p>
            <h2>Core Values That Guide Our Work</h2>
          </div>
        </div>
      </div>
      <div class="row mt-60">
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-12 wow fadeInUp animated"
          v-for="(value, i) in values"
          :key="value.id"
          :data-wow-delay="i * 100 + 'ms'"
        >
          <div class="feature-item-wrap">
            <div class="feature-icon">
              <i :class="value.icon"></i>
            </div>
            <div class="feature-content">
              <h4>{{ value.name }}</h4>
              <p>{{ value.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AboutCompany :className="false" />
  <Process />
  <ContactComponent />
  <Footer2 />
</template>
<script>
import Navbar2 from "@/components/Navbar2.vue";
import Footer2 from "@/components/Footer2.vue";
import ContactComponent from "@/components/ContactComponent.vue";
import AboutCompany from "@/components/about/AboutCompany.vue";
import Process from "@/components/Process.vue";
import axios from "axios";
export default {
  name: "AboutUs",
  components: {
    ContactComponent,
    Navbar2,
    Footer2,
    AboutCompany,
    Process,
  },
  data() {
    return {
      values: [],
    };
  },
  async beforeMount() {
    try {
      let fetchedData = await axios.get("/assets/data/values.json");
      this.values = fetchedData.data.values;
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    // Add structured data (JSON-LD) for SEO
    this.addStructuredData();
    // data-backround

    $("[data-background]").each(function () {
      $(this).css(
        "background-image",
        "url( " + $(this).attr("data-background") + "  )"
      );
    });

    //jQuery Animation
    new WOW().init();

    //Magnific Pop-up

    $(".video-play-btn").magnificPopup({
      type: "iframe",
    });
  },
  methods: {
    addStructuredData() {
      // AboutPage structured data
      const aboutPageData = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "About Us - Afino Tax Consultants",
        "description": "Learn about Afino Tax Consultants, a trusted tax and accounting firm in Dubai, UAE. Our mission, vision, and values.",
        "url": "https://www.afinotax.com/about-us",
        "mainEntity": {
          "@type": "Organization",
          "name": "Afino Tax Consultants",
          "description": "Trusted tax and accounting firm in Dubai, UAE. Expert Corporate Tax, VAT, Accounting, and Business Advisory services.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "W8 building, 5th floor, DAFZA",
            "addressLocality": "Dubai",
            "addressRegion": "Dubai",
            "addressCountry": "AE"
          },
          "telephone": "+971-54-566-8994",
          "email": "sales@afinotax.com"
        }
      };

      const script = document.createElement('script');
      script.id = 'structured-data-about';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(aboutPageData);
      document.head.appendChild(script);
    }
  },
  beforeUnmount() {
    const script = document.getElementById('structured-data-about');
    if (script) script.remove();
  },
};
</script>
